import aa from 'search-insights';
import { globals } from './globals';

// Flag to track initialization
let isInitialized = false;

/**
 * Initialize Algolia Analytics (aa) if not already initialized
 */
const initializeAA = () => {
  if (!isInitialized) {
    aa('init', {
      appId: globals.algoliaAppId, // Replace with your Algolia App ID
      apiKey: globals.algoliaSearchKey, // Replace with your Algolia API Key
    });
    isInitialized = true; // Set the flag to prevent reinitialization
  }
};

const cleanPathName = () => {
  let path = window.location.pathname;

  // Clean the path name
  if (path.includes('/product/')) {
    path = '/product';
  }

  return path;
}

const formatEventName = (eventName: string) => {
  const path = cleanPathName() || ''; // Handle null/undefined paths
  let updatedEventName = `${eventName} - ${path}`; // Combine event name and path

  // Truncate if the total length exceeds 64 characters
  if (updatedEventName.length > 64) {
    updatedEventName = `${eventName} - ${path}`.substring(0, 64);
  }

  return updatedEventName;
};


// Algolia click event handler
export const handleAlgoliaClickEvent = (queryID: string, eventName: string, sendEvent: any, hit: any) => {
  // Set the queryID in localStorage
  localStorage.setItem('queryID', queryID);

  // Call the sendEvent function
  sendEvent('click', hit, eventName);
};

// Algolia Add to Cart event handler for search results
export const handleAlgoliaAddToCartEvent = (queryID: string, eventName: string, itemCode: string) => {
  // Ensure Algolia Analytics is initialized
  initializeAA();

  aa('convertedObjectIDsAfterSearch', {
    eventName,
    index: `${globals.algoliaIndexName}`,
    queryID,
    objectIDs: [itemCode],
  });
};

/**
 * Handles the non-search "Add to Cart" event.
 * @param eventName - The name of the event.
 * @param itemCode - The code of the item.
 * @param addPath - Optional. Whether to include the current path in the event name. Default is false.
 */
export const handleNonSearchAddToCartEvent = (eventName: string, itemCode: string) => {
  // Ensure Algolia Analytics is initialized
  initializeAA();

  const updatedEventName = formatEventName(eventName);

  aa('convertedObjectIDs', {
    eventName: updatedEventName,
    index: `${globals.algoliaIndexName}`,
    objectIDs: [itemCode],
  });
};

/**
 * Handles non-search click events by tracking them with Algolia.
 * @param eventName - The name of the event.
 * @param itemCode - The code of the item being clicked.
 * @param addPath - Optional parameter to include the current path in the event name.
 */
export const handleNonSearchClickEvent = (eventName: string, itemCode: string) => {
  // Ensure Algolia Analytics is initialized
  initializeAA();

  const updatedEventName = formatEventName(eventName);

  aa('clickedObjectIDs', {
    eventName: updatedEventName,
    index: `${globals.algoliaIndexName}`,
    objectIDs: [itemCode],
  });
};
